<nav id="boo" class="sticky-stopper navbar fixed-top navbar-expand-lg navbar-light white scrolling-navbar">
  <div class="container">
    <!-- Brand -->
    <a class="navbar-brand waves-effect" href="{{ VistekUrl }}">
      <img src="https://www.vistek.ca/content/images/vistek-logo.png" height="30" alt="Vistek logo" />
    </a>

    <!-- Collapse -->
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Links -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Right -->
      <ul class="navbar-nav nav-flex-icons ml-auto">
        <a
          class="nav-link waves-effect waves-light"
          (click)="loginModal.show = 'register'"
          *ngIf="!this.isAuthenticated"
        >
          <i class="fas fa-user-circle"></i> Create Account
        </a>
        <a class="nav-link waves-effect waves-light" (click)="loginModal.show = 'login'" *ngIf="!this.isAuthenticated">
          <i data-testid="cart-login-button" class="fas fa-sign-in-alt"></i> Login
        </a>
        <a class="nav-link waves-effect waves-light" (click)="this.logout()" *ngIf="this.userProfile"
          ><i class="fas fa-user-circle"></i> Logout
        </a>
        <app-login #loginModal></app-login>
        <li class="nav-item dropdown" *ngIf="this.isAuthenticated">
          <a
            class="nav-link dropdown-toggle waves-effect"
            href="#"
            id="navbar-account"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
            data-mdb-toggle="dropdown"
          >
            <i class="far fa-user-circle"> </i> My Account ({{
              this.userProfile?.FirstName + " " + this.userProfile?.LastName
            }})
          </a>
          <div
            class="dropdown-menu dropdown-menu-right dropdown-info"
            aria-labelledby="userDropdown"
            data-dropdown-in="fadeIn"
            data-dropdown-out="fadeOut"
          >
            <a id="navbar-static-profile" class="dropdown-item waves-effect waves-light" href="/cart/profile"
              >My profile</a
            >
            <a class="dropdown-item waves-effect waves-light" href="/cart/wishlist">Wishlist</a>
            <a class="dropdown-item waves-effect waves-light" href="/cart/profile/orders">Orders</a>
            <!--<a class="dropdown-item waves-effect waves-light" (click)="createAccount()"><i
                class="fas fa-user-circle"></i> Create Account</a>
                -->
            <!--  <a class="nav-link  waves-effect waves-light" (click)="logout()" *ngIf="this.userProfile"><i
                class="fas fa-user-circle"></i>
              Logout </a>
            -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>

<ng-content></ng-content>